import { Injectable, inject } from '@angular/core';
import {
  ContactsService,
  GetUserContactsForUnionResponseDto,
  Id,
  RegistrationFormRequestDto,
  UserRegistrationService,
} from '@src/api';
import { AlertService } from '@src/core/services';
import { BehaviorSubject, catchError, Observable, throwError } from 'rxjs';
import { EnvService } from '@src/app/modules/env';

@Injectable({
  providedIn: 'root',
})
export class RegistrationService {
  private readonly contactsApiService = inject(ContactsService);
  private readonly userRegistrationService = inject(UserRegistrationService);
  private readonly env = inject(EnvService);
  private readonly alertService = inject(AlertService);

  userContacts$ = new BehaviorSubject<GetUserContactsForUnionResponseDto[] | null>(null);

  getUserContactsForUnion(unionId: string) {
    this.contactsApiService.getUserContactsForUnion(unionId).subscribe(contacts => {
      this.userContacts$.next(contacts);
    });
  }

  sendRegistrationForm(registrationFormRequestDto: RegistrationFormRequestDto): Observable<Id> {
    return this.userRegistrationService.registrationForm(registrationFormRequestDto);
  }

  addDocuments(file: Blob, fileName: string, contentType: string, parentOrganisationId: string): Observable<Id> {
    return this.userRegistrationService
      .uploadFileToRegistrationForm(file, fileName, contentType, parentOrganisationId)
      .pipe(
        catchError(err => {
          this.alertService.error(err);
          return throwError(() => err);
        }),
      );
  }

  downloadDocumentById(fileId: string): void {
    this.userRegistrationService.getFileFromRegistrationForm(fileId, 'response').subscribe(response => {
      this.env.downloadFileByHttpResponse(response);
    });
  }
}
